export default {
  path: '/projectConfiguration',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'projectConfiguration',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
